import { fmtDate, today } from '../../lib/format';

// Eintritt eines neu gemeldeten Mitarbeiters mit Tagen bis dahin (wie in der Demo): In den Branchen nach § 2a
// SchwarzArbG (Bau, Reinigung, Sicherheit, Gastronomie, Transport usw., server/src/modules/lohn/branche.ts) muss die
// Sofortmeldung vor dem ersten Arbeitstag raus. Rot bis morgen, orange in der Woche.
export function entryPill(entryDate: string, done = false): { tone: string; label: string } {
  const label = `Eintritt ${fmtDate(entryDate)}`;
  if (done) return { tone: 'neu', label };
  const t = today();
  const [y, m, d] = entryDate.split('-').map(Number);
  const n = Math.round((Date.UTC(y!, m! - 1, d!) - Date.UTC(t.year, t.month - 1, t.day)) / 86400000);
  const when =
    n < 0
      ? `vor ${-n} ${n === -1 ? 'Tag' : 'Tagen'}, Meldung überfällig`
      : n === 0
        ? 'heute'
        : n === 1
          ? 'morgen'
          : `in ${n} Tagen`;
  return { tone: n <= 1 ? 'bad' : n <= 7 ? 'warn' : 'info', label: `${label} (${when})` };
}
